













import { Component, Prop, Vue } from 'vue-property-decorator'
import { AccountLoginCredentials } from '@/interfaces'

@Component
export default class LoginForm extends Vue {
  credentials: AccountLoginCredentials = {
    email: '',
    password: ''
  }

  loading: boolean = false
  loadingError: string = ''

  async login () {
    this.loading = true
    this.loadingError = ''

    try {
      await this.$store.dispatch('account/login', this.credentials)
    } catch (error) {
      this.loadingError = error.message
    } finally {
      this.loading = false
    }
  }
}
